import _util from './lib/util.js';
import _debug from './lib/debug.js';

// 如果是移动设备/电视 接管`console.log`
if (_util.isTouch || window.yunos || window.tv || !window.chrome) {
  console.log = _debug.log.bind(_debug);
}
// 挂载到全局
if (!window.debug) {
  window.debug = _debug;
}

module.exports = _debug;



/** WEBPACK FOOTER **
 ** ./index.js
 **/